<template>
  <svg class="summary-icon" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      opacity="0.4"
      d="M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663Z"
      :fill="props.secondaryColor"
    />
    <path
      d="M10.4731 10.6202C10.3864 10.6202 10.2998 10.6002 10.2198 10.5468L8.1531 9.3135C7.63977 9.00684 7.25977 8.3335 7.25977 7.74017V5.00684C7.25977 4.7335 7.48643 4.50684 7.75977 4.50684C8.0331 4.50684 8.25977 4.7335 8.25977 5.00684V7.74017C8.25977 7.98017 8.45977 8.3335 8.66643 8.4535L10.7331 9.68684C10.9731 9.82684 11.0464 10.1335 10.9064 10.3735C10.8064 10.5335 10.6398 10.6202 10.4731 10.6202Z"
      :fill="props.primaryColor"
    />
  </svg>
</template>

<script setup>
/* global defineProps */
const props = defineProps({
  primaryColor: {
    type: String,
    default: '#3C67D6'
  },
  secondaryColor: {
    type: String,
    default: '#3C67D6'
  },
  secondaryOpacity: {
    type: Number,
    default: 0.4
  }
})

</script>
